import { ApiParameter, get, patch, post, request } from "@insite/client-framework/Services/ApiService";

export interface RelatedTaxonomy {
  id: string;
  targetTaxonomyId: string;
  priority: number;
}

export interface TaxonomyRecommendationModel {
    id: string;
    sourceTaxonomyId: string;
    sourceTaxonomyName: string;
    modifiedBy: string;
    modifiedOn: string;
    createdBy: string;
    createdOn: string;
}
export interface addCatRequest {
    id: string;
    sourceTaxonomyId:string;
    relatedTaxonomies: RelatedTaxonomy[];
    onSuccess?: (result: addCatResponse) => void;
    onError?: (error: string) => void;
}

export interface addCatResponse {
    [key: string]: any;
}

export interface TaxonomyRecommendationRequest extends ApiParameter {
    Page?: number;
    PageSize?: number;
    Sort?: string;
    SourceCategoryName?: string;
    onSuccess?: (result: TaxonomyRecommendationResponse) => void;
    onError?:(error:string)=>void;
}

export interface TaxonomyRecommendationResponse {
    taxonomyRecommendationModels: TaxonomyRecommendationModel[];
    [key: string]: any;
}

export interface Category {
    id: string;
    sourceTaxonomyId: string;
    relatedTaxonomies: RelatedTaxonomy[];
    // Add other properties as needed
}

const addTaxonomyApi = "/api/v2/taxonomyrecommendation";


export function getTaxnomyAddCat(model: addCatRequest) {
    return post<addCatResponse>(`${addTaxonomyApi}`, model);
}

export function patchTaxonomy(model: addCatRequest) {
    const { id, onSuccess, onError, ...body } = model;
    return patch<any>(`${addTaxonomyApi}`, model);
}

export function getTaxonomyRecommendations(parameter?: TaxonomyRecommendationRequest) {
    return get<TaxonomyRecommendationResponse>(addTaxonomyApi, parameter);
}

export function getTaxonomyCategoryById(id: string, parameter?: ApiParameter) {
    return get<Category>(`${addTaxonomyApi}/${id}`, parameter);
}
